/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';
import {
  AEOAPIApi,
  ApiKeyAPIApi,
  CompanyAPIApi,
  PolicyAPIApi,
  PublicAPIApi,
  RoleAPIApi,
  SettingsAPIApi,
  TeamAPIApi,
  TerritoryAPIApi,
  UserAPIApi,
  UserAPIV2Api,
} from '@demand-iq/user-sdk';
import { ClientId, Token } from '../hooks/useToken';

interface AuthClients {
  user: UserAPIApi;
  userV2: UserAPIV2Api;
  roles: RoleAPIApi;
  company: CompanyAPIApi;
  forgot: PublicAPIApi;
  apiKey: ApiKeyAPIApi;
  policies: PolicyAPIApi;
  teams: TeamAPIApi;
  settings: SettingsAPIApi;
  territory: TerritoryAPIApi;
  aeo: AEOAPIApi;
}
interface AuthContext {
  login: (clientId: ClientId, token: Token, userId: string) => void;
  logout: () => void;
  clients: AuthClients;
}

export const AuthContext = createContext<AuthContext>({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  login: (clientId: ClientId, token: Token, userId: string) => {},
  logout: () => {},
  clients: {} as any,
});
